import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PdfSettingsApiService } from '../../../pdf-settings/services/pdf-settings-api.service';
import { PdfSettingsTemplateModel } from '../../../pdf-settings/models';

@Component({
  selector: 'rnpl-pdf-template-control',
  templateUrl: './pdf-template-control.component.html',
})
export class PdfTemplateControlComponent implements OnDestroy {

  @Input() control: FormControl;
  @Input() addEmptyOption: boolean = false;

  public templatesList: PdfSettingsTemplateModel[] = [];

  @Output() fieldChanged: EventEmitter<any> = new EventEmitter<any>();

  private destroy$: ReplaySubject<any> = new ReplaySubject<any>(1);

  constructor(
    private pdfSettingsApiService: PdfSettingsApiService
  ) {
    this.getTemplates();
  }

  public getTemplates(): void {
    this.pdfSettingsApiService.getPdfSettingsTemplates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((templates: PdfSettingsTemplateModel[]) => {
        this.templatesList = templates;
        if (this.addEmptyOption) {
          this.templatesList.push({name: '-'} as PdfSettingsTemplateModel)
        }
      });
  }

  public updateField(fieldValue: any): void {
    if (fieldValue === '-') {
      fieldValue = null;
      this.control.patchValue(null);
    }
    this.fieldChanged.emit(fieldValue);
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }


}
